import { Loading } from 'carbon-components-react'
import { Container, ContentContainer } from '../../components/Wrapper/Wrapper'
import TileHeader from '../../components/TileHeader/TileHeader'
import styled from 'styled-components'
// hooks
import useRegistriesGrid from './useRegistriesGrid'

const Registries = () => {
  const {
    addRegistryButton,
    registrySearch,
    registriesGrid,
    registryLoading,
  } = useRegistriesGrid()

  return (
    <Container>
      <ContentContainer>
        <TileHeader
          title="Registries"
          size="lg"
        />
        {
          registryLoading ?
            <Loading/>
            :
            <></>
        }
        <RegistriesContent>
          <ActionBar>
            {registrySearch()}
            {addRegistryButton()}
          </ActionBar>
          {registriesGrid()}
        </RegistriesContent>
      </ContentContainer>
    </Container>
  )
}

export default Registries

const RegistriesContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px;
  background-color: #fff;
`

const ActionBar = styled.div`
  width: 100%;
  height: fit-content;
  background-color: #fff;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`
